import { useEffect, useState } from 'react'

import { AxiosResponse } from 'axios'
import { Card } from 'components'
// import useLoading from "hooks/useLoading"
import { useLoading, useModal } from 'hooks'
import {
  ConsolidationServices
  //IAggregatedParamsConsolidacao
} from 'services/NGT/Parameterization'
import { COLORS, SPACING } from 'utils'
import { FORMAT } from 'utils'

import {
  AreaCollapse,
  BusinessUnitCollapse,
  CompanyCollapse,
  ExecutivesCollapse
} from './components'
export type EndPoint = 'E' | 'C' | 'A' | 'B'
export default function Consolidation() {
  const { setLoading, setMsgErro } = useLoading()
  const [listDiretoriaExecutiva, setListDiretoriaExecutiva] = useState<any[]>(
    []
  )
  const { showModal } = useModal()
  const [listEmpresa, setListEmpresa] = useState<any[]>([])
  const [listArea, setListArea] = useState<any[]>([])
  const [listUnidadeNegocio, setListUnidadeNegocio] = useState<any[]>([])

  // *** Código abaixo foi comentado devido a não implementação das rotas agregadas ***

  // const getInitialData = () => {
  //   ConsolidationServices()
  //     .aggregatedParametrizacaoConsolidacao()
  //     .then((response: AxiosResponse<IAggregatedParamsConsolidacao>) => {
  //       setListDiretoriaExecutiva(
  //         response.data.parametrizacao_diretoriaConsolidacao
  //       )
  //       setListEmpresa(response.data.parametrizacao_empresaConsolidacao)
  //       setListArea(response.data.parametrizacao_areaConsolidacao)
  //       setListUnidadeNegocio(
  //         response.data.parametrizacao_unidadeNegocioConsolidacao
  //       )
  //     })
  //     .catch(() => {
  //       showModal({
  //         hideButtonCancel: true,
  //         message: 'Erro ao obter dados iniciais',
  //         txtButtonConfirm: 'Fechar',
  //         type: 'error'
  //       })
  //     })
  // }

  // useEffect(() => {
  //   getInitialData()
  // }, [])

  // GET DATA
  useEffect(() => {
    const getExecutives = new Promise((res, rej) =>
      ConsolidationServices()
        .getAllExecutives()
        .then(({ data }) => res(data))
        .catch((err) => 
          // rej(err)
          showModal({
            hideButtonCancel: true,
            message: 'Erro ao obter os dados da pesquisa.',
            txtButtonConfirm: 'OK',
            type: 'alert'
          })
        )
    )

    const getCompanys = new Promise((res, rej) =>
      ConsolidationServices()
        .getAllCompanies()
        .then(({ data }) => res(data))
        .catch((err) => 
          // rej(err)
          showModal({
            hideButtonCancel: true,
            message: 'Erro ao obter os dados da pesquisa.',
            txtButtonConfirm: 'OK',
            type: 'alert'
          })
        )
    )

    const getArea = new Promise((res, rej) =>
      ConsolidationServices()
        .getAlltAreaConsolidation()
        .then(({ data }) => res(data))
        .catch((err) => 
          // rej(err)
          showModal({
            hideButtonCancel: true,
            message: 'Erro ao obter os dados da pesquisa.',
            txtButtonConfirm: 'OK',
            type: 'alert'
          })
        )
    )

    const getBusiness = new Promise((res, rej) =>
      ConsolidationServices()
        .getAllBusinessUnit()
        .then(({ data }) => res(data))
        .catch((err) => 
          // rej(err)
          showModal({
            hideButtonCancel: true,
            message: 'Erro ao obter os dados da pesquisa.',
            txtButtonConfirm: 'OK',
            type: 'alert'
          })
        )
    )

    const getData = async () => {
      setLoading('loading')
      try {
        const response = await Promise.allSettled([
          getExecutives,
          getCompanys,
          getArea,
          getBusiness
        ])

        response.forEach((el) => {
          if (el.status === 'rejected') {
            setMsgErro('Error obter dados.')
            setLoading('error')
            return
          }
        })

        response[0].status === 'fulfilled' &&
          setListDiretoriaExecutiva(response[0].value as [])
        response[1].status === 'fulfilled' &&
          setListEmpresa(response[1].value as [])
        response[2].status === 'fulfilled' &&
          setListArea(response[2].value as [])
        response[3].status === 'fulfilled' &&
          setListUnidadeNegocio(response[3].value as [])

        setLoading('idle')
      } catch (error: any) {
        setLoading('error')
      }
    }
    getData()
  }, [])

  const getAllEndPoints = {
    A: async () => ConsolidationServices().getAlltAreaConsolidation(),
    B: async () => ConsolidationServices().getAllBusinessUnit(),
    C: async () => ConsolidationServices().getAllCompanies(),
    E: async () => ConsolidationServices().getAllExecutives()
  }

  // ADD ITEM CONSOLIDACAO
  const createEndPoints = {
    A: async (obj: any) => ConsolidationServices().createAreaConsolidation(obj),
    B: async (obj: any) => ConsolidationServices().createBusinessUnit(obj),
    C: async (obj: any) => ConsolidationServices().createCompanies(obj),
    E: async (obj: any) => ConsolidationServices().createExecutive(obj)
  }

  const setDataCreateEndPoints = {
    A: (obj: any) => setListArea(obj),
    B: (obj: any) => setListUnidadeNegocio(obj),
    C: (obj: any) => setListEmpresa(obj),
    E: (obj: any) => setListDiretoriaExecutiva(obj)
  }

  const handleNewContent = async (data: any, type: EndPoint) => {
    setLoading('loading')
    try {
      const response = await createEndPoints[type](data)
      if (!response.data.sucesso)
        throw new Error('Erro ao inserir dados. Tente Novamente.')

      setDataCreateEndPoints[type]((oldState) => [
        ...oldState,
        response.data.valor
      ])
      setLoading('idle')
      showModal({
        hideButtonCancel: true,
        message: 'Inserido com sucesso',
        txtButtonConfirm: 'Fechar',
        type: 'success'
      })
    } catch (error: any) {
      setMsgErro(
        error?.response?.data?.title || 'Ocorreu um erro, tente novamente!'
      )
      setLoading('error')
    }
  }

  // #####
  // EDIT ITEM CONSOLIDACAO
  //####
  const updateEndPoints = {
    A: async (obj: any) => ConsolidationServices().updateAreaConsolidation(obj),
    B: async (obj: any) => ConsolidationServices().updateBusinessUnit(obj),
    C: async (obj: any) => ConsolidationServices().updateCompanies(obj),
    E: async (obj: any) => ConsolidationServices().updateExecutive(obj)
  }

  const handleEditContent = async (objRequest: any, type: EndPoint) => {
    setLoading('loading')
    try {
      const response = await updateEndPoints[type](objRequest)
      if (!response.data.sucesso)
        throw new Error('Erro ao inserir dados. Tente Novamente.')

      const resp = await getAllEndPoints[type]()
      setDataCreateEndPoints[type](resp.data)

      setLoading('idle')
      showModal({
        hideButtonCancel: true,
        message: 'Atualizado com sucesso',
        txtButtonConfirm: 'Fechar',
        type: 'success'
      })
    } catch (error: any) {
      setMsgErro(
        error?.response?.data?.title || 'Ocorreu um erro, tente novamente!'
      )
      setLoading('error')
    }
  }

  // #####
  // DELETE ITEM CONSOLIDACAO
  //####
  const deleteEndPoints = {
    A: async (id: number) =>
      ConsolidationServices().deleteAreaConsolidation(id),
    B: async (id: number) => ConsolidationServices().deleteBusinessUnit(id),
    C: async (id: number) => ConsolidationServices().deleteCompanies(id),
    E: async (id: number) => ConsolidationServices().deleteExecutive(id)
  }

  const handleDeleteContent = async (objRequest: number, type: EndPoint) => {
    setLoading('loading')
    try {
      const response = await deleteEndPoints[type](objRequest)
      if (!response.data.sucesso)
        throw new Error('Erro ao inserir dados. Tente Novamente.')
      const resp = await getAllEndPoints[type]()
      setDataCreateEndPoints[type](resp.data)
      setLoading('idle')
      showModal({
        hideButtonCancel: true,
        message: 'Deletado com sucesso',
        txtButtonConfirm: 'Fechar',
        type: 'success'
      })
    } catch (error: any) {
      setMsgErro(
        error?.response?.data?.title || 'Ocorreu um erro, tente novamente!'
      )
      setLoading('error')
    }
  }

  return (
    <Card
      marginLeft={SPACING.spacing20}
      marginRight={SPACING.spacing20}
      marginBottom={SPACING.spacing100}
      padding={SPACING.spacing20}
      boxShadow={`0 0 1em ${COLORS.lightGray}`}
    >
      <ExecutivesCollapse
        listDiretoriaExecutiva={FORMAT.orderByLast(listDiretoriaExecutiva)}
        add={handleNewContent}
        edit={handleEditContent}
        del={handleDeleteContent}
      />
      <CompanyCollapse
        listCompanys={FORMAT.orderByLast(listEmpresa)}
        add={handleNewContent}
        edit={handleEditContent}
        del={handleDeleteContent}
      />
      <AreaCollapse
        listAreas={FORMAT.orderByLast(listArea)}
        add={handleNewContent}
        edit={handleEditContent}
        del={handleDeleteContent}
      />
      <BusinessUnitCollapse
        listBusiness={FORMAT.orderByLast(listUnidadeNegocio)}
        add={handleNewContent}
        edit={handleEditContent}
        del={handleDeleteContent}
      />
    </Card>
  )
}
